import { render, staticRenderFns } from "./Pois.vue?vue&type=template&id=a0928182&scoped=true"
import script from "./Pois.vue?vue&type=script&lang=js"
export * from "./Pois.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a0928182",
  null
  
)

export default component.exports